import HereToHelpCard, { HereToHelpCardProps } from ".";
import IconLoader from "@/features/Common/components/IconLoader";
import { useTranslation } from "react-i18next";
import { Stack, Typography } from "@mui/material";

export default function HereToHelpCardExamples() {
  const { t } = useTranslation();

  const exampleProps: HereToHelpCardProps = {
    title: t("HereToHelpCard.title"),
    description: t("HereToHelpCard.description"),
    button: {
      text: t("HereToHelpCard.button.text"),
      url: "/home/get-medical-assistance/prompt",
      icon: <IconLoader icon="SpeakToADoctorIcon" />,
    },
  };
  const exampleProps2: HereToHelpCardProps = {
    title: t("HereToHelpCard.title"),
    description: t("HereToHelpCard.description"),
    button: {
      text: t("HereToHelpCard.button.text"),
      url: "/home/get-medical-assistance/intercare",
      icon: <IconLoader icon="SpeakToADoctorIcon" />,
    },
  };

  return (
    <Stack mt={4} gap={4}>
      <Stack
        flexDirection="column"
        alignItems="center"
        justifyContent="space-between"
        gap={1}
      >
        <Typography
          fontWeight={600}
          variant="h3"
          sx={{
            fontWeight: 600,
            fontSize: 16,
            lineHeight: 1.5,
          }}
        >
          {"Chat for Medical Assistance"}
        </Typography>
        <HereToHelpCard {...exampleProps} />
      </Stack>

      <Stack
        flexDirection="column"
        alignItems="center"
        justifyContent="space-between"
        gap={1}
      >
        <Typography
          fontWeight={600}
          variant="h3"
          sx={{
            fontWeight: 600,
            fontSize: 16,
            lineHeight: 1.5,
          }}
        >
          {"Choose consultation"}
        </Typography>
        <HereToHelpCard {...exampleProps2} />
      </Stack>
    </Stack>
  );
}
